import {
  type WebObservabilityOptions,
  configureWebObservability,
} from "@infinitaslearning/observability-web";
import { isLocal, isTest, serviceENV } from "constants/env-constants";

export const APP_NAME = "app-he-stm-additionals-web-frontend";

export type WebObservability = ReturnType<typeof configureWebObservability>;

interface ObservabilityInstance {
  apm: WebObservability | null;
  initialized: boolean;
}

export const WebObservabilityService = (() => {
  let instance: ObservabilityInstance | null = null;

  const _init = (): ObservabilityInstance => {
    const localOptions: WebObservabilityOptions = {
      serviceName: APP_NAME,
      serverUrl:
        "https://a2ccf4ce09324b819578f6253260eca7.apm.westeurope.azure.elastic-cloud.com:443",
      serverUrlPrefix: undefined,
      sendCredentials: false,
    };

    const options: WebObservabilityOptions = {
      serviceName: APP_NAME,
      environment: serviceENV(),
      serviceVersion: "0.0.1",
      transactionSampleRate: 1,
      disableInstrumentations: ["fetch", "xmlhttprequest"],
    };

    const apm = configureWebObservability(isLocal() || isTest() ? localOptions : options);
    return { apm, initialized: true };
  };

  const getInstance = (): ObservabilityInstance => {
    if (!instance) {
      instance = _init();
    }
    return instance;
  };

  return {
    getInstance,
    isInitialized: (): boolean => getInstance().initialized,
  };
})();
